import { head } from 'lodash'
import toastr from 'toastr'

import ApiService from '../data/services/ApiService'
import {
    usoCfdiValores,
    formaPagoValores,
    MetodoPagoValores,
    CondicionesDePagoValores,
    StatusDePagoValores,
    MonedaValores,
    c_Periodicidad,
    c_Meses
} from '../data/catalogs/CatalogosSAT'

const getMatchedOption = (options = [], value) => {
    if (!value) {
        return null
    }

    return head(options.filter((option) => option.value === value)) || null
}

const getMatchedCustomer = (clientes = [], clienteId, receptor = {}) => {
    if (clienteId) {
        return clientes.find((cliente) => {
            const candidateId = cliente.id || cliente.value

            return candidateId && String(candidateId) === String(clienteId)
        }) || null
    }

    if (!receptor) {
        return null
    }

    return clientes.find((cliente) => {
        if (receptor.rfc && cliente.rfc === receptor.rfc) {
            return true
        }

        if (receptor.email && cliente.email === receptor.email) {
            return true
        }

        if (receptor.razonSocial && cliente.razonSocial === receptor.razonSocial) {
            return true
        }

        return false
    }) || null
}

const getMatchedLocation = (lugares = [], lugarExpedicion) => {
    if (!lugarExpedicion) {
        return null
    }

    return lugares.find((lugar) => lugar.value === lugarExpedicion) || null
}

const getMatchedGlobalInfo = (informacionGlobal = null) => {
    if (!informacionGlobal) {
        return null
    }

    const periodicidad = getMatchedOption(c_Periodicidad, informacionGlobal.Periodicidad)
    const meses = getMatchedOption(c_Meses, informacionGlobal.Meses)
    const yearValue = informacionGlobal.Año || informacionGlobal.year
    const year = yearValue ? { value: String(yearValue), label: String(yearValue) } : null

    if (!periodicidad && !meses && !year) {
        return null
    }

    return { Periodicidad: periodicidad, Meses: meses, Año: year }
}

export const duplicateInvoiceAndNavigate = async ({ invoiceId, history, setLoading, mode }) => {
    try {
        setLoading(true)
        const response = await ApiService.duplicarFactura(invoiceId, mode ? { mode } : {})
        if (!response.data?.success) {
            toastr.error(response.data?.message || 'No pude duplicar la factura.')
            return
        }

        const duplicatedFactura = response.data?.data?.factura

        history.push('/facturas/nueva', {
            duplicatedFactura
        })
    } catch (error) {
        const message = error.response?.data?.message || 'No pude duplicar la factura.'

        toastr.error(message)
    } finally {
        setLoading(false)
    }
}

export const getDuplicatedFacturaFormState = ({ duplicatedFactura, clientes = [], lugares = [] }) => {
    const metodoPago = getMatchedOption(MetodoPagoValores, duplicatedFactura?.metodoPago)
    const formaPago = getMatchedOption(formaPagoValores, duplicatedFactura?.formaPago)
    const pagada = metodoPago?.value === 'PPD'
        ? head(StatusDePagoValores.filter((option) => option.value === false))
        : head(StatusDePagoValores.filter((option) => option.value === true))
    const informacionGlobal = getMatchedGlobalInfo(duplicatedFactura?.informacionGlobal)

    return {
        cliente: getMatchedCustomer(clientes, duplicatedFactura?.clienteId, duplicatedFactura?.receptor),
        lugarExpedicion: getMatchedLocation(lugares, duplicatedFactura?.lugarExpedicion),
        usoCFDI: getMatchedOption(usoCfdiValores, duplicatedFactura?.usoCFDI),
        metodoPago,
        formaPago,
        condicionesPago: getMatchedOption(CondicionesDePagoValores, duplicatedFactura?.condicionesDePago),
        pagada,
        moneda: getMatchedOption(MonedaValores, duplicatedFactura?.moneda),
        tipoCambio: duplicatedFactura?.tipoCambio ?? '',
        lineItems: duplicatedFactura?.lineItems || [],
        tipoDeComprobante: duplicatedFactura?.tipoDeComprobante || 'I',
        informacionGlobal,
        showInformacionGlobalForm: Boolean(informacionGlobal || duplicatedFactura?.receptor?.rfc === 'XAXX010101000'),
        cfdiRelacionados: Array.isArray(duplicatedFactura?.cfdiRelacionados) ? duplicatedFactura.cfdiRelacionados : [],
        replacementContext: duplicatedFactura?.replacementContext || null
    }
}
